import {Component, computed, effect, HostListener, Input, OnInit, signal, WritableSignal} from '@angular/core';
import {EstadoTramiteEnum, TramiteItem, TramiteTipoRequisitoItem} from '../interfaces/tramites.interface';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {TramiteService} from '../../services/tramite.service';
import {catchError, debounceTime, distinctUntilChanged, map, Subject, throwError} from 'rxjs';
import {switchMap, tap} from "rxjs/operators";
import {LoginServices} from "../../../../auth/login/services/login.service";
import {CatalogoInterface, ProyectoItem} from "../../../interfaces/proyecto.interface";
import {TarifarioInterface} from "../../../interfaces/pagos.interface";
import {ProyectoService} from "../../../proyectos/services/proyecto.service";
import {SdetTramiteService} from "../../services/sdet-tramite.service";
import {MessageService} from "primeng/api";
import {
    AreaChanged,
    AreasInterfaces,
    RecepcionObrasDetalleInterface,
    RecepcionProyectoDetalleInterface,
    TipoAreaEnum,
    TipoObrasDetalleInterface
} from "../interfaces/formulario.interfaces";
import {
    isAlphaNumericValidEvent,
    isValidPercentageEvent,
    isValidQuantityEvent
} from "../../../../shared/services/utils-service";
import Swal from "sweetalert2";
import {Location} from "@angular/common";
import {CatalogoService} from "../../../../shared/services/catalogo-service";
import {FormularioAService} from "../../services/formulario-a.service";

@Component({
    selector: 'app-formulario-c',
    templateUrl: './formulario-c.component.html',
    providers: [MessageService],
    styleUrls: ['./formulario-c.component.scss']
})
export class FormularioCComponent implements OnInit {
    idTramite: string | null = null
    idTipoProyecto: number = 1
    tramiteCompleto: boolean = false
    entorno: CatalogoInterface[] = []
    tarifa: number = 0
    nombreTramite: string = ''
    // proyectoAsignado: ProyectoItem[] = []
    esConstruccion: WritableSignal<boolean> = signal(false)
    etapaRecepcion: CatalogoInterface[] = []
    etapaRecepcionSeleccionada: CatalogoInterface | null = null
    porcentajeParcelacion: number = 0
    porcentajeConstruccion: number = 0
    totales: number = 0
    U: number = 0
    idProyecto: string | null = null
    requisitoTipoTramite: TramiteTipoRequisitoItem[] = [];
    selected: TramiteItem = null!
    condicion: boolean = true;
    obrasRealizadasUrbanizacion: TipoObrasDetalleInterface[] = [];
    obrasEdificacion: TipoObrasDetalleInterface[] = [];
    recepcionProyectoDetalle: RecepcionProyectoDetalleInterface[] = [];
    @Input() _showLoader: boolean = false
    prjId$ = this.route.params.pipe(map((params) => params['idProyecto']));
    isLoading = signal(false);
    activeAccordionIndex: number[] | undefined = [1];
    formularioActual: 'generales' | 'construccion' | 'formc' = 'formc';

    constructor(public router: Router, private route: ActivatedRoute,
                private proyectoService: ProyectoService, private catalogoService: CatalogoService,
                protected tramiteService: TramiteService, private loginServices: LoginServices,
                private sdetTramiteService: SdetTramiteService, private messageService: MessageService,
                private location: Location, private formularioAService:FormularioAService) {
    }

    ngOnInit(): void {
        this.preFetchProyectoId()
        if (this.tramiteService.idProyecto()) {
            this.proyectoService.getGeneralesProyecto(this.tramiteService.idProyecto()!)
                .pipe(
                    catchError(error => {
                        return throwError(error)
                    })
                )
                .subscribe(
                    resp => {
                        if (resp.status == 200) {
                            this.tramiteService.proyectoAsignado.set(resp.body!)
                            this.getInfoAreaProyecto(this.tramiteService.idProyecto()!,this.tramiteService.proyectoAsignado()[0].idTipoProyecto!, "tipoareas");
                            if (this.tramiteService.proyectoAsignado()[0].idTipoProyecto != 4) {
                                this.esConstruccion.set(false)
                                this.tramiteService.mostrarCatalogoDeObras(1).subscribe(
                                    {
                                        next: (result) => {
                                            if (result) {
                                                this.obrasRealizadasUrbanizacion = result;
                                            }
                                        },
                                        error: (error) => {
                                            console.log(error)
                                        },
                                        complete: () => {
                                        }
                                    }
                                );
                                this.getInfoRecepcionProyecto(Number(this.tramiteService.idProyecto()!));
                            } else {
                                this.esConstruccion.set(true)
                                this.tramiteService.mostrarCatalogoDeObras(2).subscribe(
                                    {
                                        next: (result) => {
                                            if (result) {
                                                this.obrasEdificacion = result;
                                            }
                                        },
                                        error: (error) => {
                                            console.log(error)
                                        },
                                        complete: () => {
                                        }
                                    }
                                );
                                this.getInfoRecepcionProyecto(Number(this.tramiteService.idProyecto()!))
                            }
                            this.catalogoService.getCatalogo('etapa_recepcion')
                                .subscribe(
                                    resp => {
                                        this.etapaRecepcion = resp
                                    }
                                )
                        }
                    }
                )
        }
        this.route.paramMap.subscribe((params: ParamMap) => {
            if (params.get('idTramite') != null) {
                this.idTramite = +params.get('idTramite')! ? params.get('idTramite') : null
                if (this.idTramite != null) {
                    this.sdetTramiteService.obtenerSdetItem(this.tramiteService.idProyecto()!, this.idTramite)
                        .subscribe(
                            resp => {
                                this.selected = resp.body!
                            }
                        )
                    this.tramiteService.getTramite(this.idTramite)
                        .subscribe(
                            resp => {
                                this.nombreTramite = resp.body?.nombreTramite!
                            }
                        )
                }
            }
            if (params.get('idProyecto') != null) {
                this.idProyecto = +params.get('idProyecto')! ? params.get('idProyecto') : null
                this.requisitoTipoTramite = [{idTipoTramite: 1}]
                if (this.idProyecto != null) {
                    this.tramiteService.getRequisitosPorParametros(this.idTramite!, this.idProyecto, this.requisitoTipoTramite);
                }
            }
            this.catalogoService.getCatalogo('entorno')
                .subscribe(
                    resp => {
                        this.entorno = resp
                    }
                )
        });
    }

    private preFetchProyectoId() {
        console.log(`preFetchProyectoId`)
        this.prjId$.subscribe((id) => {
            if (id) {//load everything prj sequence.
                this.tramiteService.idProyecto.set(id)
            }
        });
        console.log(`params -> this.tramite.idProyecto  -> ${this.tramiteService.idProyecto()}`)
    }

    //Metodo para activar el formulario condicional
    esFormularioActivo(tipo: string): boolean {
        return this.formularioActual === tipo;
    }

    //Validacion para activar los inputs de las areas, si tienen o no requieren pago o no tienen un tramite asignado o vienen vacios
    isReadOnly = computed(() => {
        return this.selected?.idEstadoTramite === EstadoTramiteEnum.NoRequierePago || this.selected.idEstadoTramite === EstadoTramiteEnum.PagoRealizado 
        || this.selected.idEstadoTramite === null || this.selected.idEstadoTramite === undefined;
    });

    /**Metodo obtiene la informacion de areas y de la area total del proyecto previamente registrado en el FU.*
     */
    getInfoAreaProyecto(idProyecto: string, tipoProyecto: number, info: string | null) {
        if (info == "tipoareas" && tipoProyecto != null || undefined) {
            this.tramiteService.getObtenerTipoAreas(idProyecto!, []).subscribe(
                resp => {
                    this.tramiteService.tiposAreas.set(resp)
                    this.tramiteService.areaTotalSignal.set(this.getAreaByTipo(TipoAreaEnum.Areaproyecto!));
                }
            );
        }
    }
    onInputChange(event: any) {
        if (this.porcentajeConstruccion > 0) {
            this.porcentajeConstruccion = isValidPercentageEvent(this.porcentajeConstruccion, event);
        }
        if (this.porcentajeParcelacion > 0) {
            this.porcentajeParcelacion = isValidPercentageEvent(this.porcentajeParcelacion, event);
        }
    }

    onInputTable(obra: TipoObrasDetalleInterface, event: any) {
        if (obra.porcentaje != null || obra.porcentaje != "") {
            obra.porcentaje = isValidPercentageEvent(obra.porcentaje!, event);
        }
    }

    onInputCantidad(obra: TipoObrasDetalleInterface, event: any) {
        if (obra.cantidad != null || obra.cantidad != undefined) {
            obra.cantidad = isValidQuantityEvent(obra.cantidad!, event);
        }
    }

    isNumericValid(event: KeyboardEvent) {
        if (event.key) {
            isAlphaNumericValidEvent(event, 1);
        }
    }

    onChangeCalcularTarifa() {
        let areaTotal=this.getAreaByTipo(TipoAreaEnum.Areaproyecto!)
        if (areaTotal != null && areaTotal != 0) {
            this._showLoader = true;
            this.calcularTarifa().pipe(
                debounceTime(200), // Debounce for 200 milliseconds
                distinctUntilChanged(), // Only proceed if the query has changed
                catchError(error => {
                    let text = error.mensaje;
                    if (error.error && error.error.mensaje) {
                        text = error.error.mensaje; // Extract the custom message
                    } else if (error.message) {
                        text = error.message; // Fallback to the general error message
                    }
                    if (text.includes('api')) {
                        text = 'Ocurrió un error al procesar, intente mas tarde'
                    }
                    this.tramiteService.textTarifa='Calculo de tarifa no disponible en este momento.';
                    this._showLoader = false;
                    return throwError(error.statusText);
                })
            ).subscribe({
                next: (result) => {
                    if (result && result.body) {
                        let respuesta: TarifarioInterface[] | null = result.body
                        for (let i of respuesta!) {
                            if (i.total) {
                                this.tramiteService.textTarifa='';
                                this.tarifa = parseFloat(i.total.toFixed(2))!
                            } else {
                                this.tarifa = 0
                            }
                            console.log(`this.tarifa = ${this.tarifa}`)
                            console.log(`institucion =${this.loginServices.session()?.perfil.idInstitucion}`)
                            this._showLoader = false;
                        }
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {
                }
            });
        }
    }

    calcularTarifa() {
        console.log(`calcularTarifa()`)
        let datos_calcular: TarifarioInterface[] = [
            {
                idEntorno: this.tramiteService.proyectoAsignado()[0].idEntorno!,
                idTramite: parseInt(this.idTramite!, 10),
                idTipoArea:this.tramiteService.tiposAreas().find(area => area.idTipoArea === TipoAreaEnum.Areaproyecto)?.idTipoArea!,
                area: this.getAreaByTipo(TipoAreaEnum.Areaproyecto!),
                idProyecto: this.tramiteService.idProyecto(),
                creadoPor: this.loginServices.session()?.perfil.usuario,
                idInstitucion: this.loginServices.session()?.perfil.idInstitucion,
                idSolicitud: this.tramiteService.proyectoAsignado()[0].idSolicitud!
            }
        ]
        return this.tramiteService.calcularTarifa(datos_calcular);
    }

    completarTramite() {
        if(this.isLoading()) return;
        this.isLoading.set(true);
        this.obtenerSdetItemTramites();
    }
    /**
     * <h4>Obtener informacion tramite</h4>
     * <p>Este metodo obtiene la informacion actualizada del proyecto vinculado al tramite</p>
     * <ul>
     *     <li>se detecto que las estaditisticas para los requisitos de tipo form, text en la respuesta no obtiene los datos actualizados cuando se completan
     *     de ultimo estos requisitos.</li>
     *     <li>este metodo al darle click al boton finalizar obtiene la información del proyecto o solictud vinculado al tramite,
     *     para obtener la informacion completa y actualizada cuando el usuario finalice el tramite</li>
     *     <li>el trámite para ser completado con exito debe cumplir con la informacion y todos los requisitos obligatorios.</li>
     *     <li>si el trámite ya cuenta con informacion y los requitos obligatorios completos se procesa y finaliza el trámite.</li>
     * </ul>
     * @since 13/01/2025
     */
    obtenerSdetItemTramites(){
        this.sdetTramiteService.obtenerSdetItem(this.tramiteService.idProyecto()!, this.idTramite!)
            .subscribe(
                {
                    next: (resp) => {
                        if (resp) {
                            this.selected = resp.body!
                            this.procesarTramite();
                        }
                    },
                    error: (error) => {
                        console.log(error)
                        this.isLoading.set(false);
                    },
                    complete: () => {
                        this.isLoading.set(false);
                    }
                }
            )
    }
   //TODO: Reescribir validaciones de este metodo, evaluar si es posible procesar en el backend. 28NOV2024
    procesarTramite(){
        if (!this.etapaRecepcionSeleccionada) {
            this.messageService.add({
                severity: 'error',
                summary: '',
                detail: 'Debe seleccionar la etapa del avance de obra y completar detalles de obras realizadas.'
            });
            return;
        }
        if (!this.esConstruccion() && this.etapaRecepcionSeleccionada.id == '1') {
            if (this.porcentajeParcelacion == 0 || this.porcentajeParcelacion == null) {
                this.messageService.add({
                    severity: 'error',
                    summary: '',
                    detail: 'Favor ingresar el porcentaje de parcelacion.'
                });
                return;
            }
        }
        if (this.esConstruccion() && this.etapaRecepcionSeleccionada.id == '1') {
            if (this.porcentajeConstruccion == 0 || this.porcentajeConstruccion == null) {
                this.messageService.add({
                    severity: 'error',
                    summary: '',
                    detail: 'Favor ingresar el porcentaje de construcción.'
                });
                return;
            }
        }
        if (this.selected) {
            if (!(this.selected.qtycumplidos === this.selected.qtyrequeridos)){
                Swal.fire({
                    icon: "warning",
                    title: "Error",
                    text: "Favor debe cargar los archivos y documentos requeridos",
                    showDenyButton: true,
                    showConfirmButton: false,
                    denyButtonText: `Ok`
                }).then(r => console.log('Favor debe cargar los archivos y documentos requeridos'));
                return;
            }
        }
        if (!this.tarifa) {
            this.messageService.add({
                severity: 'error',
                summary: '',
                detail: 'Favor calcular la tarifa del trámite.'
            });
            return;
        }
        //Procesar los datos segun el tipo de flujo
        this.validacionPrimerFlujoCompletarTramite();
        this.tramiteCompleto = true;
    }

    validacionPrimerFlujoCompletarTramite() {
        this._showLoader = true;
        if (this.esConstruccion()) {
            /**Caso cuando es construccion*/
            this.procesarObrasRealizadas(this.obrasEdificacion, "Edificacion");
            this.tramiteService.completeFormProcess(this.selected)
                .pipe(
                    tap(_ => console.log('SDet actualizado correctamente')),
                    debounceTime(1000), // Debounce for 1000 milliseconds = 1 sec                        distinctUntilChanged(), // Only proceed if the query has changed
                    switchMap(query => this.tramiteService.completeFormProcess(this.selected)),
                    catchError(error => {
                        return throwError(() => error);
                    })
                ).subscribe(
                resp => {
                    if (resp.status == 200 || resp.status == 201) {
                        this._showLoader = false;
                        const id = this.selected.idProyecto ? this.selected.idProyecto : 0;
                        this.router.navigate(['/users/pagos/tramites', id])
                            .then(() => {
                                console.log(`tramites done` + JSON.stringify(this.route.snapshot.queryParams))
                            });
                    }
                }
            )
        } else {
            /**Caso cuando no es construccion*/
            this.procesarObrasRealizadas(this.obrasRealizadasUrbanizacion, "Urbanizacion");
            this.tramiteService.completeFormProcess(this.selected)
                .pipe(
                    tap(_ => console.log('SDet actualizado correctamente')),
                    debounceTime(1000), // Debounce for 1000 milliseconds = 1 sec                            distinctUntilChanged(), // Only proceed if the query has changed
                    switchMap(query => this.tramiteService.completeFormProcess(this.selected)),
                    catchError(error => {
                        return throwError(() => error);
                    })
                ).subscribe(
                resp => {
                    if (resp.status == 200 || resp.status == 201) {
                        this._showLoader = false;
                        const id = this.selected.idProyecto ? this.selected.idProyecto : 0;
                        this.router.navigate(['/users/pagos/tramites', id])
                            .then(() => {
                                console.log(`tramites done` + JSON.stringify(this.route.snapshot.queryParams))
                            });
                    }
                }
            )
        }
    }

    procesarObrasRealizadas(obrasRealizadas: TipoObrasDetalleInterface[], caller: string) {
        console.log("obras realizadas " + caller)
        let datosTipoObrasDet = obrasRealizadas.map(obras => ({
            idTipoObraUrbanizacion: obras.idTipoObraUrbanizacion,
            obra: obras.obra,
            cantidad: obras.cantidad,
            idUnidadMedida: obras.idUnidadMedida,
            unidad: obras.unidad,
            porcentaje: obras.porcentaje,
            ubicacion: obras.ubicacion,
            usuarioCreaModifica: this.loginServices.session()?.perfil.usuario,
            idProyecto: parseInt(this.tramiteService.idProyecto()!)
        }));
        this.obtenerTipoObrasDetalle(datosTipoObrasDet);
    }

    obtenerRecepcionObrasDetalle() {
        let datosRecepcionObrasDet: RecepcionObrasDetalleInterface = {
            idProyecto: parseInt(this.tramiteService.idProyecto()!),
            idEtapaRecepcion: parseInt(this.etapaRecepcionSeleccionada?.id!),
            usuario: this.loginServices.session()?.perfil.usuario!,
            porcentajeAvance: this.porcentajeParcelacion || this.porcentajeConstruccion,
        }
        this.tramiteService.procesarRecepcionObrasDet(datosRecepcionObrasDet).subscribe(
            {
                next: (result) => {
                    if (result.status == 200) {
                        console.log(`datos procesados recepcion de obras det -> ${result}`);
                        this.limpiarPorcentajes();
                    }
                },
                error: (error) => {
                    console.log(error)
                    if (error.status == 400) {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error al registrar',
                            detail: 'Fallo al registrar recepcion de obras detalle'
                        });
                    }
                },
                complete: () => {
                }
            }
        );
    }

    obtenerTipoObrasDetalle(datosObrasRealizadasDet: TipoObrasDetalleInterface[]) {
        this.tramiteService.procesarObrasRealizadasDet(datosObrasRealizadasDet, parseInt(this.tramiteService.idProyecto()!)).subscribe(
            {
                next: (result) => {
                    if (result.status == 200) {
                        console.log(`datos procesados obras relizadas det -> ${result}`);
                    }
                },
                error: (error) => {
                    console.log(error)
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error al registrar',
                        detail: 'Fallo al registrar obras relizadas'
                    });
                },
                complete: () => {
                    this.obtenerRecepcionObrasDetalle();
                    this.procesarRecepcionProyecto(this.recepcionProyectoDetalle);
                }
            }
        );
    }

    limpiarPorcentajes() {
        if (this.etapaRecepcionSeleccionada?.id == '2' || this.etapaRecepcionSeleccionada?.descripcion == "Total") {
            this.porcentajeConstruccion = 0;
            this.porcentajeParcelacion = 0;
        }
        this.porcentajeConstruccion = 0;
        this.porcentajeParcelacion = 0;
    }

    /**
     Este metodo verifica si el id de un proyecto existe antes de finalizar el tramite
     y tambien hace un update cuando se agrega un nuevo proyecto de tipo flujo 2
     */
    validacionBotonCompletarTramite(): boolean {
        return this.tramiteService.idProyecto() == null;
    }

    /**Metodo que muestra informacion de lotes y detalle de construccion*/
    getInfoRecepcionProyecto(idProyecto: number) {
        this.tramiteService.mostrarRecepcionProyectoDetalle(idProyecto).subscribe(
            {
                next: (result) => {
                    if (result) {
                        this.recepcionProyectoDetalle = result;
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {
                    this.calculoTotalesRecepcionProyecto();
                }
            }
        );
    }

    /**Metodo que calcula los totales de y se muestra en los inputs*/
    calculoTotalesRecepcionProyecto() {
        if (this.recepcionProyectoDetalle.length > 0) {
            let suma = 0;
            for (let proyectoDetalle of this.recepcionProyectoDetalle) {
                suma = suma + proyectoDetalle.cantidad!;
            }
            this.totales = this.recepcionProyectoDetalle.length;
            this.U = suma;
        }
    }

    /**Metodo que procesa los datos de la tabla ingresados*/
    procesarRecepcionProyecto(recepcionProyecto: RecepcionProyectoDetalleInterface[]) {
        console.log("procesarRecepcionProyecto")
        let datosRecepcionProyecto = recepcionProyecto.map(datos => ({
            id: datos.id,
            cantidad: datos.cantidad,
            tipo: datos.tipo,
            descripcionEntidad: datos.descripcionEntidad,
            block: datos.block,
            poligono: datos.poligono,
            viaAcceso: datos.viaAcceso,
            idProyecto: datos.idProyecto,
            origen: datos.origen,
            usuario: this.loginServices.session()?.perfil.usuario
        }));
        console.log(datosRecepcionProyecto)
        this.actualizarRecepcionProyecto(Number.parseInt(this.tramiteService.idProyecto()!), datosRecepcionProyecto);
    }

    /**Metodo que actualiza la informacion de lotes y detalle de construccion que se ingresa*/
    actualizarRecepcionProyecto(idProyecto: number, datosRecepcionProyecto: RecepcionProyectoDetalleInterface[]) {
        this.tramiteService.updateRecepcionProyectoDetalle(idProyecto, datosRecepcionProyecto).subscribe(
            {
                next: (result) => {
                    if (result.status == 200) {
                        console.log(`datos actualizado recepcion proyecto -> ${result}`);
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {
                }
            }
        );
    }

    /**Metodo que permite hacer el calculo de la tarifa de forma automatica siempre y cuando la tarifa no este vacia*/
    areaTotalEffect = effect(() => {
        if ((this.tramiteService.areaTotalSignal() !== 0 && this.tramiteService.areaTotalSignal() !== null) &&
            (this.tramiteService.proyectoAsignado().length > 0 &&
                this.tramiteService.proyectoAsignado()[0]?.idEntorno !== undefined &&
                this.tramiteService.tiposAreas().length > 0)) {
            console.log("effectArea calculo")
            setTimeout(() => {
                this.onChangeCalcularTarifa();
            }, 200);
        }
    }, {allowSignalWrites: true});

    getAreaByTipo(tipo: TipoAreaEnum) {
        return this.tramiteService.tiposAreas().find(area => area.idTipoArea === tipo)?.area!;
    }
    getTipoArea(tipo: TipoAreaEnum) {
        return this.tramiteService.tiposAreas().find(area => area.idTipoArea === tipo)?.idTipoArea!;
    }
    goBack(): void {
        this.location.back();
    }
    onReceiveTramite(selected: TramiteItem): void {
        this.selected = selected;
    }
    onChangeArea(event: any,area: number) {
        if (event.key === '.' || event.key === ' ') {
            event.preventDefault();
        }
        if (area != null && this.tramiteService.idProyecto() != null) {
            const areasRegisto: AreaChanged = {
                idTipoArea: this.getTipoArea(TipoAreaEnum.Areaproyecto!),
                idProyecto: this.tramiteService.idProyecto()!=null ? parseInt(this.tramiteService.idProyecto()!) : 0,
                area: area,
                usuarioCreaModifica: this.loginServices.session()?.perfil.usuario!
            };

            this.formularioAService.actualizarAreas(areasRegisto).pipe(
                debounceTime(200), // Debounce for 200 milliseconds
                distinctUntilChanged(), // Only proceed if the query has changed
            ).subscribe({
                next: (result) => {
                    if (result) {
                        this._showLoader = false;
                        //obtener areas con la actualizacion
                        setTimeout(() => {
                            this.getInfoAreaProyecto(this.tramiteService.idProyecto()!, this.tramiteService.proyectoAsignado()[0].idTipoProyecto!, "tipoareas");
                        }, 200);
                    }
                },
                error: (error) => {
                    console.log(error)
                },
                complete: () => {
                }
            });
        }
        if (area==0 && this.tramiteService.areaTotalSignal()==0) {
            this.messageService.add({
                severity: 'error',
                summary: '',
                detail: 'La Área de proyecto debe ser mayor que cero.'
            });
            this.tarifa = 0;
            return;
        }
        if (area==null && this.tramiteService.areaTotalSignal()==null) {
            this.tarifa = 0;
            return;
        }
        if(this.tramiteService.areaTotalSignal()==0){
            this.tarifa = 0;
            return;
        }
        if (area==null) {
            this.messageService.add({
                severity: 'error',
                summary: '',
                detail: 'La Área de proyecto no debe ser nula .'
            });
            this.tarifa = 0;
            return;
        }
    }
    @HostListener('window:beforeunload', ['$event'])
    unloadHandler(event: Event): void {
        console.log('Page refresh detected');
        this.tramiteService.idProyecto.set(null)
        this.tramiteService.resetStatus()
    }

    ngOnDestroy(): void {
        console.log(`formulario-c ngOnDestroy()->` + this.constructor.name)
        this.tramiteService.areaTotalSignal.set(0);
        this.tramiteService.tiposAreas.set([])
    }
}
